<!-- cabecalho -->
<header class="header">
    <div class="header-container color-white">
        <div class="header-title">
            <a [routerLink]="['/']" class="logo link" aria-label="irParaPrincipal">
                <span class="logo-title-container" role="separator">
                <span class="logo-denomination" role="separator">Ministério da Educação</span>
                <!-- 
                <h2 class="header-title-text">Catálogos de Cursos da Educação Profissional e Tecnólogica</h2> -->
                <h2 class="logo-main">Catálogos de Cursos da Educação Profissional e Tecnólogica</h2>
                </span>
            </a>

        </div>
        <div class="accessibility">
            <button role="separator" class="high-contrast-btn color-white link text-uppercase cursor-pointer"
            (click)="onAltoContraste()"
            >
              Alto Contraste
            </button>
            <span class="separator" role="separator"></span> 
            <a href="https://www.vlibras.gov.br/"  class="v-libras link text-uppercase">Vlibras</a>
        </div>

    </div>

</header>